import { render, staticRenderFns } from "./classList.vue?vue&type=template&id=4625f317&scoped=true&"
import script from "./classList.vue?vue&type=script&lang=ts&"
export * from "./classList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4625f317",
  null
  
)

export default component.exports